import React, { useState } from 'react';
import { RequiredDialogInput, DialogInput, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import { useCommonConfigFunctions } from '../../../hooks/useCommonConfigFunctions';

function ConfigurationDataPropertyEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {

    const [fieldErrors, setFieldErrors] = useState({});

    const { createFunction, updateFunction, deleteFunction } = useCommonConfigFunctions("configurationDataProperties", "configuration data property");

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }

    const createOrUpdate = (object) => {
        return object.id ? updateFunction(object) : createFunction(object);
    }

    return (
        <CommonConfigDialog title={"Configuration Data Property - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={createOrUpdate} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} canDelete={true} deleteFunction={deleteFunction}>
            <RequiredDialogInput controlId="formConfigDataPropertyName" title="Name" placeholder="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <DialogInput controlId="formConfigDataPropertyDescription" title="Description" placeholder="Description" name="description" value={dialogData.description} error={fieldErrors.description} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default ConfigurationDataPropertyEditDialog;